export class Direction {
    readonly name: string;
    readonly value: string;

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }

    public static OUTBOUND = new Direction('outbound', 'ida');
    public static INBOUND = new Direction('inbound', 'volta');
}